import { c as _c } from "react/compiler-runtime";
import { PWD_LOW_UPPER_LETTERS, PWD_MAX_LENGTH, PWD_MIN_LENGTH, PWD_NUMERIC, PWD_SPECIAL, isPasswordEqualToUsername } from '@spa/lib/formsSchemas/commonValidations';
import React, { Fragment, ReactElement } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import styles from './password-conditions.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export enum PasswordFieldError {
  PASSWORD_REUSE = 'PASSWORD_REUSE',
}
interface Condition {
  readonly isFulfilled: (value: string) => boolean;
  readonly label: string;
  isValid: boolean;
}
const isLengthInRange = (value: string): boolean => value.length >= PWD_MIN_LENGTH && value.length <= PWD_MAX_LENGTH;
interface Props {
  readonly newPasswordValue?: string;
  readonly errorMessage?: string;
  readonly id?: string;
  readonly showPasswordReuseCondition?: boolean;
  readonly username?: string;
}
export default function PasswordConditionsComponent(t0) {
  const $ = _c(22);
  const {
    newPasswordValue,
    errorMessage,
    id,
    showPasswordReuseCondition,
    username
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("password-conditions");
  const isPasswordReuseError = errorMessage === PasswordFieldError.PASSWORD_REUSE;
  const visibleErrorMessage = isPasswordReuseError ? undefined : errorMessage;
  let t1;
  if ($[0] !== errorMessage || $[1] !== formatMessage || $[2] !== id || $[3] !== isPasswordReuseError || $[4] !== newPasswordValue || $[5] !== showPasswordReuseCondition || $[6] !== username || $[7] !== visibleErrorMessage) {
    const conditions = [{
      isFulfilled: isLengthInRange,
      label: formatMessage("error.characterCountRequired"),
      isValid: false
    }, {
      isFulfilled: _temp,
      label: formatMessage("error.lowAndUpperCaseRequired"),
      isValid: false
    }, {
      isFulfilled: _temp2,
      label: formatMessage("error.numbersRequired"),
      isValid: false
    }, {
      isFulfilled: _temp3,
      label: formatMessage("error.specialCharactersRequired"),
      isValid: false
    }, ...(username === undefined ? [] : [{
      isFulfilled: value_2 => !isPasswordEqualToUsername(value_2, username),
      label: formatMessage("error.notEmailRequired"),
      isValid: false
    }])];
    conditions.forEach(condition => {
      condition.isValid = condition.isFulfilled(newPasswordValue ?? "");
    });
    const passwordConditionsClass = isValid => classNames(styles["password-conditions__condition"], {
      [styles["password-conditions__condition--valid"]]: isValid,
      [styles["password-conditions__condition--invalid"]]: errorMessage && !isValid,
      "bold": isValid
    });
    const getLabelIcon = isValid_0 => <Fragment>{isValid_0 ? <ImageComponent src="/assets/icons/check-circle.svg" alt={formatMessage("icons.true")} width={20} height={20} /> : <ImageComponent src="/assets/icons/do-not-disturb-on.svg" alt={formatMessage("icons.false")} width={20} height={20} />}</Fragment>;
    let t2;
    if ($[9] !== errorMessage) {
      t2 = classNames(styles["password-conditions__headline"], {
        [styles["password-conditions__headline--error"]]: errorMessage
      });
      $[9] = errorMessage;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    let t3;
    if ($[11] !== formatMessage) {
      t3 = formatMessage("headline");
      $[11] = formatMessage;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] !== t2 || $[14] !== t3) {
      t4 = <div className={t2}>{t3}</div>;
      $[13] = t2;
      $[14] = t3;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    let t5;
    if ($[16] !== visibleErrorMessage) {
      t5 = visibleErrorMessage && <div className={styles["password-conditions__error"]} role="alert">{visibleErrorMessage}</div>;
      $[16] = visibleErrorMessage;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    let t6;
    if ($[18] !== formatMessage || $[19] !== isPasswordReuseError || $[20] !== showPasswordReuseCondition) {
      t6 = showPasswordReuseCondition && <span key={isPasswordReuseError ? "reuse-error" : "reuse-hint"} className={classNames(styles["password-conditions__condition"], {
        [styles["password-conditions__condition--invalid"]]: isPasswordReuseError
      })} role={isPasswordReuseError ? "alert" : undefined}>{formatMessage("error.currentPassword")}</span>;
      $[18] = formatMessage;
      $[19] = isPasswordReuseError;
      $[20] = showPasswordReuseCondition;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t1 = <div className={styles["password-conditions"]} id={id}>{t4}{t5}{t6}{conditions.map(t7 => {
        const {
          label,
          isValid: isValid_1
        } = t7;
        return <span key={label} className={passwordConditionsClass(isValid_1)}>{getLabelIcon(isValid_1)}{label}</span>;
      })}</div>;
    $[0] = errorMessage;
    $[1] = formatMessage;
    $[2] = id;
    $[3] = isPasswordReuseError;
    $[4] = newPasswordValue;
    $[5] = showPasswordReuseCondition;
    $[6] = username;
    $[7] = visibleErrorMessage;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
function _temp3(value_1) {
  return PWD_SPECIAL.test(value_1);
}
function _temp2(value_0) {
  return PWD_NUMERIC.test(value_0);
}
function _temp(value) {
  return PWD_LOW_UPPER_LETTERS.test(value);
}